'use client';

import { c as _c } from "react/compiler-runtime";
import { generateAuthorizationUrl } from '@/app/lib/entra';
import { isSupportOrAdmin } from '@/helpers/auth';
import { usePathname, useRouter } from '@/i18n/routing';
import { IconSize } from '@diamond-block/ui';
import { useSession } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import toast from 'react-hot-toast';
import { FaMicrosoft } from 'react-icons/fa';
import { ErrorDisplay } from '../feedback/ErrorDisplay';
import { KeycloakForm } from './KeycloakForm';
import { PrivilegedRequestForm } from './PrivilegedRequestForm';
export function LoginForm() {
  const $ = _c(22);
  const t = useTranslations("LoginForm");
  const {
    data: session
  } = useSession();
  const currentPathname = usePathname();
  const {
    push
  } = useRouter();
  let t0;
  if ($[0] !== currentPathname || $[1] !== push || $[2] !== t) {
    t0 = async () => {
      await toast.promise(generateAuthorizationUrl(currentPathname), {
        loading: t("generating-authorization"),
        success: authorizationUrl => {
          push(authorizationUrl);
          return t("redirecting");
        },
        error: _temp
      });
    };
    $[0] = currentPathname;
    $[1] = push;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const authorizeEntra = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FaMicrosoft size={IconSize.btn} />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("request-windows-account");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== authorizeEntra || $[8] !== t2) {
    t3 = <div className="flex w-full justify-center"><button className="btn btn-primary" onClick={authorizeEntra}>{t1} {t2}</button></div>;
    $[7] = authorizeEntra;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("or");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div className="divider">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <KeycloakForm />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== session || $[16] !== t) {
    t7 = session && isSupportOrAdmin(session) && <><div className="divider">{t("or-privileged")}</div><PrivilegedRequestForm /></>;
    $[15] = session;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t5 || $[20] !== t7) {
    t8 = <>{t3}{t5}{t6}{t7}</>;
    $[18] = t3;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp(err) {
  return <ErrorDisplay err={err} />;
}